import Icon from "./icons/Icon";
import "./Ziffernblock.css";

/**
 * Jahr tippen: vier Ziffernfelder + eigener Ziffernblock. Eigene Tasten
 * statt Handy-Tastatur: die schiebt sonst das Layout hoch und verdeckt
 * Timer und Aufgabe.
 * @category eingaben
 */
export function Ziffernblock({ wert, onChange, onAbschicken }) {
  const tippe = (z) => wert.length < 4 && onChange(wert + z);
  const voll = wert.length === 4;
  return (
    <div className="ziffernblock">
      <div className="ziffern" aria-label={`Dein Tipp: ${wert || "leer"}`} role="status">
        {[0, 1, 2, 3].map((i) => (
          <span key={i} className={i < wert.length ? "voll" : i === wert.length ? "cursor" : ""}>
            {wert[i] || ""}
          </span>
        ))}
      </div>
      <div className="tasten">
        {["1", "2", "3", "4", "5", "6", "7", "8", "9"].map((z) => (
          <button key={z} type="button" className="taste" onClick={() => tippe(z)}>
            {z}
          </button>
        ))}
        <button
          type="button"
          className="taste leise"
          onClick={() => onChange(wert.slice(0, -1))}
          aria-label="Löschen"
          disabled={!wert}
        >
          <Icon name="loeschen" size={24} />
        </button>
        <button type="button" className="taste" onClick={() => tippe("0")}>
          0
        </button>
        <button
          type="button"
          className="taste ok"
          onClick={onAbschicken}
          disabled={!voll}
          aria-label="Tipp abschicken"
        >
          <Icon name="check" size={24} />
        </button>
      </div>
    </div>
  );
}

/**
 * Abgegebener Tipp: dieselben Felder, fest.
 * @category eingaben
 */
export function ZiffernFest({ wert }) {
  const text = String(wert ?? "").padEnd(4, " ");
  return (
    <div className="ziffern fest" aria-label={`Dein Tipp: ${wert ?? "—"}`}>
      {[0, 1, 2, 3].map((i) => (
        <span key={i}>{text[i].trim() || "–"}</span>
      ))}
    </div>
  );
}

export default Ziffernblock;
